import { Action, createReducer, on } from "@ngrx/store";
import { CheckoutActions } from "../actions";
import { CheckoutSubmitOrderState } from "../checkout.state";

const initialState: CheckoutSubmitOrderState = {
    loading: null,
    success: null,
    error: null,
    acceptTerms: null,
    purchaseOrderNumber: null,
    rejectFlag: null,
    submitFlag: null,
};

const CheckoutSubmitOrderReducer = createReducer(
    initialState,
    on(
        CheckoutActions.updateSubmitOrderStatus,
        (state: CheckoutSubmitOrderState, { payload }) => ({
            ...state,
            ...payload
        })
    ),
    on(
        CheckoutActions.submitRequestOrder,
        (state: CheckoutSubmitOrderState) => ({
            ...state,
            loading: true,
            success: null,
            error: null,
            submitFlag: false,
        })
    ),
    on(
        CheckoutActions.submitPlaceOrder,
        (state: CheckoutSubmitOrderState) => ({
            ...state,
            loading: true,
            success: null,
            error: null,
            submitFlag: false,
        })
    ),
    on(
        CheckoutActions.submitOrderSuccess,
        (state: CheckoutSubmitOrderState) => ({
            ...state,
            loading: null,
            success: true,
            error: null,
        })
    ),
    on(
        CheckoutActions.submitOrderFail,
        (state: CheckoutSubmitOrderState, { payload }) => ({
            ...state,
            loading: null,
            success: null,
            error: payload,
        })
    ),
    on(
        CheckoutActions.rejectOrder,
        (state: CheckoutSubmitOrderState) => ({
            ...state,
            loading: true,
            success: null,
            error: null,
            submitFlag: false,
        })
    ),
    on(
        CheckoutActions.rejectOrderSuccess,
        (state: CheckoutSubmitOrderState) => ({
            ...state,
            loading: null,
            success: true,
            error: null,
            rejectFlag: true
        })
    ),
    on(
        CheckoutActions.clearCheckoutState,
        () => ({ ...initialState })
    )
);

export function reducer(state: CheckoutSubmitOrderState | undefined, action: Action) {
    return CheckoutSubmitOrderReducer(state, action);
}